import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import contactSuccessIcon from "../../../../../Assets/icons/contact_success.png";
import Button from "../../../../Button";
import Header from "../../../../Header";

function EmailSent({ onClose }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("HELP_MODAL", { returnObjects: true });

  return (
    <div className="acoris-help-modal__body acoris-email-sent">
      <img
        src={contactSuccessIcon}
        alt=""
        className="acoris-email-sent__icon"
      />
      <Header
        title={
          TRANSLATION?.SUCCESS?.TITLE ||
          "Nous allons vous recontacter dans les plus brefs délais"
        }
        highlight={TRANSLATION?.SUCCESS?.HIGHLIGHT || "vous recontacter"}
      />
      <Button
        type="primary-outlined"
        className="acoris__actions--close-btn"
        onClick={onClose}
      >
        {TRANSLATION?.BUTTON?.CLOSE || "Fermer"}
      </Button>
    </div>
  );
}

export default EmailSent;
